import $ from 'jquery';
import 'jqueryUI';
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import EventEmitter from 'EventEmitter';

var SearchBlockMixin = {
    componentDidMount: function () {
        SearchBlockManager.on('change', this.update);
    },
    update: function (data){
        if (this.props.slide != SearchBlockManager.getActiveSlide()) {
            this.setState({
                open: false
            });
        } else if (data) {
            this.setState({
                open: true
            });
            if (this.setFocus) {
                this.setFocus();
            }
        }
    },
    prev: function (e) {
        var $slide = $(e.currentTarget).closest('.ms-slide');
        if (!this.state.open && $slide.hasClass('ms-sl-selected')) {
            SearchBlockManager.prev();
            e.stopPropagation();
            e.preventDefault();
        }
    },
    next: function (e) {
        var $slide = $(e.currentTarget).closest('.ms-slide');
        if (!this.state.open && $slide.hasClass('ms-sl-selected')) {
            SearchBlockManager.next();
            e.stopPropagation();
            e.preventDefault();
        }
    },
    close: function (e){
        e.stopPropagation();
        e.preventDefault();
        document.location.hash = '_';
        this.setState({open: false});
    },
    open: function(e){
        if (this.props.slide == SearchBlockManager.getActiveSlide()) {
            this.setState({open: true});
            if (this.setFocus) {
                this.setFocus();
            }
        } else {
            SearchBlockManager.showSlide(this.props.slide);
        }
    }
};
var TireSearchBlock = React.createClass({
    mixins: [SearchBlockMixin],
    componentDidMount: function () {
        var validValues = this.props.validValues,
            validateField = this.validateField;
        ['width', 'profile', 'wheel_size'].forEach(function(key) {
            $('#id_tire_' + key).autocomplete({
                source: validValues[key]
            })
        });
    },
    getInitialState: function() {
        return {open: false, tireState: 0, valid: true, canSubmit: false};
    },
    preventTextInput: function(event) {
        var e = event.nativeEvent;
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    },
    handleWidthChange: function(e) {
        var $input = $(e.target),
            val = $input.val(),
            overMinLen = 2 < val.length;
        if (this.validateField('width', overMinLen) && overMinLen) {
            $('#id_tire_profile').focus();
        }
    },
    handleProfileChange: function(e) {
        var $input = $(e.target),
            val = $input.val(),
            overMinLen = 1 < val.length;
        if (this.validateField('profile', overMinLen) &&  overMinLen) {
            $('#id_tire_wheel_size').focus();
        }
    },
    handleWheelSizeChange: function(e) {
        var $input = $(e.target),
            val = $input.val(),
            overMinLen = 1 < val.length;
        if (this.validateField('wheel_size', overMinLen) && overMinLen) {
            $('#tire-search .btn-submit').focus();
            //$input.blur();
        }
    },
    setFocus: function() {
        $(this.getDOMNode()).find('input[type!=hidden]').first().focus();
    },
    focus: function(e) {
        var $this = $(e.target),
            $par = $this.closest('.form-container'),
            target = $this.data('target') || 0;
        this.setState({tireState: target});
    },
    setFieldValidState: function($field, isValid) {
        $field.toggleClass('has-errors', !isValid);
    },
    validateField: function(key, setInvalidClass) {
        if (setInvalidClass !== false) {
            setInvalidClass = true;
        }

        var $form = $(this.getDOMNode()).find('form'),
            $field = $('#id_tire_' + key),
            value = '' + $field.first().val(),
            isValid = true;
        if (value) {
            isValid = _.contains(this.props.validValues[key], value);
        }
        if (isValid || setInvalidClass) {
            this.setFieldValidState($field, isValid);
        }
        var canSubmit = this.state.canSubmit && isValid && value.length;
        this.setState({canSubmit: canSubmit});
        return isValid;

    },
    allFieldsEmpty: function() {
        var keys = ['width', 'profile', 'wheel_size'],
            joined = _.reduce(keys, function(memo, key) {
                var $input = $('#id_tire_' + key);
                return memo + $input.val();
            }, '');
        return 0 === joined.length;
    },
    validateAll: function(e) {
        var that = this,
            allValid = _.every(_.map(_.keys(this.props.validValues), that.validateField));
        this.setState({
            valid: allValid,
            canSubmit: allValid && !this.allFieldsEmpty()
        });
    },
    blur: function(e) {
        var $this = $(e.target),
            $par = $this.closest('.form-container'),
            target = $this.data('target') || 0;
        this.setState({tireState: 0});
        this.validateAll(e);
    },
    keyPressSubmit: function(e) {
        if (e.key == 'Enter') {
            this.submit(e);
        }
    },
    render: function() {
        var open = this.state.open ? 'open no-swipe': '',
            validClass = this.state.valid ? '': ' has-errors',
            btnClass = this.state.canSubmit ? '': ' disabled';
        return (
            <form id="tire-search-form" method="GET">
              <div className="title">
                <h3>Hae renkaita</h3>
                <a href="/rengashaku/" className="browse">Selaa kaikkia renkaita</a>
              </div>
              <div className="dropdowns">
                <input type="hidden" name="order" value="stock" />
                <input type="hidden" name="page" value="1" ref="page" />
                <input className="small" id="id_tire_width" type="number" name="width" ref="width" placeholder="Leveys" autoComplete="off" onFocus={this.focus} onBlur={this.blur} onChange={this.handleWidthChange} onKeyDown={this.preventTextInput} data-target="1"/>
                <input className="small" id="id_tire_profile" type="number" name="profile" ref="profile" onKeyDown={this.preventTextInput} autoComplete="off" onFocus={this.focus} onBlur={this.blur} placeholder="Profiili" onChange={this.handleProfileChange} data-target="2" />
                <input id="id_tire_wheel_size" type="number" name="wheel_size" ref="wheel_size" onKeyDown={this.preventTextInput} autoComplete="off" onFocus={this.focus} onBlur={this.blur} onChange={this.handleWheelSizeChange} placeholder="Halkaisija (vanteen koko)" data-target="3" />
              </div>
              <div className="action">
                <input className={'btn ' + btnClass} type="submit" value="HAE" onClick={this.submit} />
              </div>
            </form>
        );
    },
    submit: function(e) {
        e.preventDefault()
        if (!this.state.canSubmit) {
            return;
        }
        var data = $(_.filter($("#tire-search-form input"), function(el) {
            return $(el).val() != '';
        })).serialize();

        var gaLabel = this.refs.width.getDOMNode().value + '-' +
              this.refs.profile.getDOMNode().value + '-' +
              this.refs.wheel_size.getDOMNode().value;
        document.location.href='/rengashaku/#' + data;
    }
});

var WheelSearchBlock = React.createClass({
    mixins: [SearchBlockMixin],
    getInitialState: function() {
        return {
            brand: "",
            model: "",
            details: "",
            open: false
        };
    },
    createBrandOption: function(brand) {
        return (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
        );
    },
    createModelOption: function(model) {
        return (
            <option key={model.id} value={model.id}>{model.name}</option>
        );
    },
    createDetailsOption: function(details) {
        return (
            <option key={details.id} value={details.id}>{details.details}</option>
        );
    },
    createDetails: function (details){
        if (!details || _.keys(details).length < 2) {
            return null;
        }
        return (
            <div className="custom-select">
                <select name="car-detail" onChange={this.handleDetailsChange} value={this.state.details}>
                    {this.getChooseOption()}
                    {_.map(_.sortBy(details, function(el) {return el.order;}), this.createDetailsOption)}
                    <optgroup label=""></optgroup>
                </select>
            </div>
        );
    },
    handleBrandChange: function(e) {
        this.setState({
            brand: e.target.value,
            model: "",
            details: ""
        });
    },
    handleModelChange: function(e) {
        var model = e.target.value,
            details = "";
        if (model) {
            // If only one details for the model, set the details state now
            var detail = this.props.brands[this.state.brand].models[e.target.value].details;
            if (_.keys(detail).length == 1) {
                details = _.keys(detail)[0];
            }
        }
        this.setState({
            model: e.target.value,
            details: details
        });
    },
    handleDetailsChange: function(e) {
        this.setState({details: e.target.value});
    },
    getEmptyOption: function() {
        return <option key="0" value="">&mdash;</option>;
    },
    getChooseOption: function(str) {
        if (!str) {
            str = '';
        }
        return <option key="0" value="">{'Valitse ' + str}</option>;
    },
    canSubmit: function () {
        return this.state.brand && this.state.model && this.state.details;
    },
    render: function() {
        var models = {},
            modelEls,
            details = {},
            btnClass = this.canSubmit()? 'btn-red': 'disabled';
        if (this.state.brand) {
            models = this.props.brands[this.state.brand].models;
            modelEls = _.map(_.sortBy(models, function(el) {return el.name;}), this.createModelOption);
            modelEls.splice(0, 0, this.getChooseOption('malli'));
        } else {
            modelEls = this.getEmptyOption();
        }
        if (this.state.brand && this.state.model) {
            details = models[this.state.model].details;
        }
        var open = this.state.open ? 'open no-swipe': '';

        return (
            <form className="form" method="GET">
              <div className="title">
                <h3>Hae auton mukaan</h3>
                <a href="/vannehaku/">Selaa kaikkia vanteita</a>
              </div>
              <div className="dropdowns">
                <select name="brand" onChange={this.handleBrandChange} value={this.state.brand}>
                    <option key="0" value="">Valitse automerkki</option>
                    {_.map(_.sortBy(this.props.brands, function(el) {return el.name;}), this.createBrandOption)}
                    <optgroup label=""></optgroup>
                </select>
                <select name="model" placeholder="Automalli" onChange={this.handleModelChange} value={this.state.model}>
                    {modelEls}
                    <optgroup label=""></optgroup>
                </select>
                {this.createDetails(details)}
              </div>
              <div className="action">
                <input className={'btn ' + btnClass}  type="submit" value="HAE VANTEITA" onClick={this.submitWheelSearch} />
                <input className={'btn ' + btnClass}  type="submit" value="HAE RENKAITA" onClick={this.submitTireSearch} />
              </div>
            </form>
        );
    },
    submitTireSearch: function(e) {
        e.preventDefault();
        if (!this.canSubmit()) {
            return;
        }
        var data = $.param(Object.assign({}, {}, {order: 'stock'}));
        delete data['open'];
        document.location.href='/rengashaku/' + this.props.brands[this.state.brand].slug + '/' +
            this.props.brands[this.state.brand].models[this.state.model].slug + '/' +
            this.state.details +
            '#' + data;
    },
    submitWheelSearch: function(e) {
        e.preventDefault();
        if (!this.canSubmit()) {
            return;
        }
        var data = $.param(Object.assign({}, {}, {order: 'stock'}));
        delete data['open'];
        document.location.href='/vannehaku/' + this.props.brands[this.state.brand].slug + '/' +
            this.props.brands[this.state.brand].models[this.state.model].slug + '/' +
            this.state.details +
            '#' + data;
    }
});

var WheelTireSearchBlock = React.createClass({
    mixins: [SearchBlockMixin],
    getInitialState: function() {
        return {
            open: false
        };
    },
    render: function () {
        var open = this.state.open ? 'open no-swipe': '';
        return (
            <div className={'slide-content ' + open} onClick={this.open}>
                <img src="/static/nettivanne/webshop/img/haen-molempia.png" alt="Haen molempia" />
                <div className="next-slide search-control" onClick={this.next}></div>
                <div className="prev-slide search-control" onClick={this.prev}></div>
                <div className="form-container">
                    <button type="button" className="btn btn-red btn-close" onClick={this.close}>X</button>
                    <div className="form"><p>Tulossa pian</p></div>
                </div>
            </div>
        );
    }
});

var SearchBlockManager = (function () {
    var ee = new EventEmitter(),
        slider,
        $el;

    var checkHash = function (e) {
        var hash = document.location.hash.substr(1);
        if (hash == 'vannehaku') {
            SearchBlockManager.openSlide(0);
        } else if (hash == 'rengashaku') {
            SearchBlockManager.openSlide(1);
        }
    };

    var init = function(el) {
        ReactDOM.render(<WheelSearchBlock slide={0} brands={wheel_search_by_car_data} />, document.getElementById('wheel-search'));
        ReactDOM.render(<TireSearchBlock slide={1} validValues={valid_tire_values} />, document.getElementById('tire-search'));
    };

    return {
        on: ee.on.bind(ee),
        off: ee.off.bind(ee),
        init: function(el) {
            init(el);
        },
        showSlide: function(index) {
            slider.api.gotoSlide(index);
            ee.trigger('change');
        },
        openSlide: function(index) {
            slider.api.gotoSlide(index);
            ee.trigger('change', [true]);
        },
        prev: function() {
            slider.api.previous();
        },
        next: function() {
            slider.api.next();
        },
        getActiveSlide: function () {
            return slider.api.currentSlide.index;
        }
    };
})();

export default SearchBlockManager;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/search-block-manager.js
 **/